import React from 'react';
import './index.scss';

const NB_RETRY = 10;
const INTERVAL_TIME = 5000;

// a mettre autour de l'image et masser "src" en params

class ImgLoaderTrick extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			valid: false,
			interval: null,
			retry: 0,
		};
	}

	async isValid(url) {
		try {
			var http = new XMLHttpRequest();
			http.open('HEAD', url, false);
			http.send();
			return http.status == 200;
		} catch (e) {
			return false;
		}
	}

	async checkImage() {
		const valid = await this.isValid(this.props.src);
		if (valid || this.state.retry >= NB_RETRY) {
			clearInterval(this.state.interval);
			this.setState({ valid: true, interval: null });
		} else {
			this.setState({ retry: this.state.retry + 1 });
		}
	}

	componentDidMount() {
		if (this.props.src) {
			this.checkImage();
			this.setState({
				interval: setInterval(async () => {
					this.checkImage();
				}, INTERVAL_TIME),
			});
		} else {
			this.setState({ valid: true });
		}
	}

	componentWillUnmount() {
		if (this.state.interval) clearInterval(this.state.interval);
	}

	render() {
		if (!this.state.valid) {
			return (
				<div className="img-loader-container">
					{' '}
					<Loader />
				</div>
			);
		} else {
			return { ...this.props.children };
		}
	}
}

function Loader() {
	return (
		<div class="lds-grid">
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
	);
}

export default ImgLoaderTrick;
